import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useAppSelector } from "src/app-redux/hooks";
import { selectNotify } from "src/app-redux/settings/settingsSlice";

type Props = {};

export function Notification({}: Props): React.ReactElement {
  const notify = useAppSelector(selectNotify);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (notify)
      enqueueSnackbar(notify.message, {
        ...notify.options,
        preventDuplicate: true,
      });
  }, [notify]);
  return <></>;
}
